import TutorialMessage from "./TutorialMessage";
import { useEffect } from 'react';

export default function DrawLineGuideline({ endpointRequirement, guideOutline, endpoint, tutorialState, errorPopup, }){

  

  useEffect(() => {

    function mouseMove(e){
      let { clientX, clientY } = e;

      let endEndpoint = document.querySelector('[endpoint=end]');
      if( endEndpoint ){

        let boundingRect = endEndpoint.getBoundingClientRect();
        let x0 = boundingRect.x;
        let x1 = boundingRect.x + boundingRect.width;
        let y0 = boundingRect.y;
        let y1 = boundingRect.y + boundingRect.height;

        let inX = x0 < clientX && clientX < x1;
        let inY = y0 < clientY && clientY < y1;

        if( inX && inY && window.__mouseDown ){
          endEndpoint.style.border = '3px solid lime';
        }else{
          endEndpoint.style.border = '3px solid red';
        }



      }
    }
    window.addEventListener('mousemove',mouseMove)
    return () => {
      window.removeEventListener('mousemove',mouseMove);
    }
  })


  let { selector } = endpointRequirement;

  
  if( endpointRequirement.relativeOffset && endpointRequirement.offset ){
    throw Error("Cannot appeal to both 'relativeOffset' and 'offset' for drag endpoint.");
  }

  let element;

  let targetSelectorBounds;
  if( endpointRequirement.selector ){
    element = document.querySelector(selector);
    if( !element ){

      console.log("RETURNING NULL FOR GUIDELINE ELEMENT!",selector);

      return null;
    }
    targetSelectorBounds = element.getBoundingClientRect();
  }

  let isCorrectEndpointForMessage = (
    tutorialState.message?.positionAt === endpoint
  );

  let tutorialMessageTest = true && isCorrectEndpointForMessage && ( 
    <TutorialMessage {...{
      errorPopup:{
        position:(tutorialState.message?.offset) || (
          {
            transform:'translate(100%,0) translate(10px,0)',
          }
        ),
        text:tutorialState.message.default,
        debugLocation:guideOutline,
        
      },
      message:tutorialState.message,
    }}/>
  )
  

  if( targetSelectorBounds && endpointRequirement.offset ){

    if( !element ){

      console.log("RETURNING NULL FOR GUIDELINE ELEMENT!");
      return null;
    }
    
    let { left, top, width, height } = targetSelectorBounds;

    



    let offset = endpointRequirement.offset || endpointRequirement.relativeOffset || {};
    let leftOffset = offset.left || 0;
    let topOffset = offset.top || 0;

    let finalLeft = left + leftOffset;
    let finalTop = top + topOffset;

    height = offset.height || height;
    width = offset.width || width;

    return (
      <div
        id="HELLO"
        endpoint={endpoint}
        ref={null}
        //class={"no-pointer-hover-green"}
        tutorialrole={"endpoint"}
        style={{
          border:'3px solid red',
          
          pointerEvents:'none',//({start:'none',end:'unset'})[endpoint],

          position:'fixed',
          

          left:finalLeft-4,
          top:finalTop,
          width,
          height,
          zIndex:20000,
          ...(endpointRequirement.style || {})

        }}>

        {tutorialMessageTest}
      </div>
        
    )
  }

  let relativeOffset = endpointRequirement.relativeOffset;
  let { dim } = endpointRequirement;
  dim = dim || 15;
  let halfDim = dim/2;

  let anchor = targetSelectorBounds || guideOutline;

  


  return (

    <div 
      tutorialrole={"endpoint"}
      endpoint={endpoint}
      //class={"no-pointer-hover-green"}
      style={{
        width:relativeOffset.width || dim,
        height:relativeOffset.height || dim,
        border:'3px solid red',
        position:'absolute',
        borderRadius:40,
        //pointerEvents:'none',


        top:(anchor.top + relativeOffset.top * anchor.height - halfDim),
        left:(anchor.left + relativeOffset.left * anchor.width - halfDim),
        zIndex:20000
      }}>
      {tutorialMessageTest}
    </div>
  )


}
